/* =============================================================
 * import
 * ========================================================== */
import ScrollHint from "scroll-hint";

/* =============================================================
 * export function
 * ========================================================== */

// =============================================================
// tableの拡張（大きいテーブルの横スクロール化）
// =============================================================
export function tableScrollHint() {

  const contents = document.querySelector(".contents");

  if (contents) {
    // wrap table settings
    const contentsArea = contents.querySelectorAll("table");
    if (contentsArea !== null) {
      const tableAry = Array.prototype.slice.call(contentsArea);
      tableAry.forEach(function(e) {
        // テーブルが親要素より大きいかチェック
        const parentElementWidth = e.parentElement.offsetWidth;
        const tableWidth = e.offsetWidth;

        if (tableWidth > parentElementWidth) {
          if (!e.closest(".table_wrap")) {
            e.outerHTML = '<div class="table_wrap">' + e.outerHTML + '</div>';
          }
        }
      });
    }

    // scrollableJS settings
    const scrollableTrigger = contents.querySelectorAll(".table_wrap");
    if (scrollableTrigger !== null) {
      const scrollableAry = Array.prototype.slice.call(scrollableTrigger);
      scrollableAry.forEach(function(scrollable) {
        const scrollHintIcon = scrollable.querySelector('.scroll-hint-icon-wrap');
        if (scrollHintIcon) {
          scrollHintIcon.remove();
        }
      });
      new ScrollHint(scrollableAry, {
        scrollHintIconAppendClass: 'scroll-hint-icon-white',
        // applyToParents: true,
        i18n: {
          scrollable: 'スクロールできます',
        },
      });
    }
  }
}
